import { render, staticRenderFns } from "./HRWorkbench.vue?vue&type=template&id=1952baba"
import script from "./HRWorkbench.vue?vue&type=script&lang=js"
export * from "./HRWorkbench.vue?vue&type=script&lang=js"
import style0 from "./HRWorkbench.vue?vue&type=style&index=0&id=1952baba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports